export default (state = {}, action) => {
    switch (action.type) {

        case 'GETTING_ANNOUNCEMENTS':
            return Object.assign({},state,{
                ui: action.payload.ui
            })
        case 'GET_ANNOUNCEMENTS_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        case 'GET_ANNOUNCEMENTS_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                items: action.payload.items
            })
        default:
            return state
    }
}
